import { useNavigate } from '@tanstack/react-router';
import clsx from 'clsx';

interface ProBadgeProps {
  isPro?: boolean;
  className?: string;
}

export function ProBadge({ isPro = false, className }: ProBadgeProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!isPro) {
      navigate({ to: '/subscription' });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={clsx(
        "relative inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
        "bg-gradient-to-r from-orange-400 to-red-400 text-white",
        "overflow-hidden",
        "pro-badge-shine",
        isPro ? [
          "opacity-70",
          "cursor-default"
        ] : [
          "cursor-pointer",
          "transition-transform hover:scale-105"
        ],
        className
      )}
      aria-label={isPro ? "Pro feature" : "Pro feature - Click to upgrade"}
      disabled={isPro}
    >
      <span className="relative z-10">Pro</span>
    </button>
  );
}